import { Button, type ButtonProps } from "@immi/ui/components/button"

import { cn } from "@/lib/utils"

type TextActionProps = Omit<ButtonProps, "variant" | "size"> & {
  /** `muted` for secondary moves, `brand` for the one link that leads on. */
  tone?: "muted" | "brand"
}

/**
 * A quiet action that reads as text: no box, a 44px hit area, underline on
 * hover. Use `asChild` to wrap a `Link`.
 */
export function TextAction({
  tone = "muted",
  className,
  ...props
}: TextActionProps) {
  return (
    <Button
      variant="link"
      className={cn(
        "h-auto min-h-11 gap-1.5 px-0 py-0 text-left whitespace-normal underline-offset-4 disabled:opacity-40 has-[>svg]:px-0",
        tone === "muted"
          ? "font-medium text-ink-muted hover:text-ink-body"
          : "font-semibold text-primary-700",
        className
      )}
      {...props}
    />
  )
}
